<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

  // Code for hiding elements according to region

  console.log("region " + pageRegion);
// console.log("lang " + pageLang);

// var url = window.location.href;
// var section = document.getElementById("littergenie-cares");
// var reviews = document.querySelector('.product-tab-item.review');
// var headerDescription = document.querySelector('.header-description');
// var videoDescription = document.querySelector('.video-description');
// var question = document.getElementById('question-15d9d2f4-1bdd-49c8-9a99-58246020f05c-3');
// var comparison_table = document.querySelector('.comparison-content');
// var whereToBuy = document.querySelector('.where-to-buy-container');
// var partnersLink = document.querySelector('#shopify-section-footer > footer > div > div > div > div:nth-child(4)');
// var listItems = partnersLink.querySelectorAll('li');
// var frenchHeading = document.getElementById('shopify-section-template--17264834052377__5a2c91a3-78e3-47dd-80d9-d34147becef2');
// var reviewsSectionHomepage = document.querySelector('.litter-genie-sections-customer-review-block');
// var accessoriesLink = document.querySelector('#shopify-section-footer > footer > div > div > div > div:nth-child(3) > div > div > ul > li:nth-child(3)');

var subscribeBanner = document.getElementById('subscribe-container');

if(pageRegion == 'GB') {
    console.log('This is UK');
  // $('#shopify-section-footer > footer > div > div > div > div:nth-child(4) > div > div > ul > li:nth-child(1)').hide();
  subscribeBanner.style.display = "block";
}


$(document).ready(function() {
   if ($('.how-to-use-text').text().trim() === '') {
      console.log('EMPTY DIV');
        $('.how-to-use-text, .product-tab-item.how-to-use').hide();
    }
});

if(pageRegion == 'FR' || pageRegion == 'DE' || pageRegion == 'GB' ) {
  console.log('REGION')
  $('.product-tab-item.review').hide();


}


if(pageRegion == 'GB') {
  if (window.location.pathname === '/en-uk/pages/where-to-buy') {
    window.location.href = 'https://petwastegenie.com/en-uk';
}
  const menuItems = document.querySelectorAll('ul.list-menu li.menu-lv-item');
   menuItems[2].style.display = 'none';

}


 

// // Hide Partners Link from footer
// if(pageRegion == "DE" || pageRegion === "GB" || pageRegion == "FR") {
// if (listItems.length >= 4) {
//   listItems[1].style.display = 'block';
// }
//    $(".faqs-row .faqs-item:eq(2)").hide();
// }

// if(pageRegion == "DE" || pageRegion === "GB" || pageRegion === "FR" || pageRegion === "CA") {
//    accessoriesLink.style.display = "none";
//   $('.list-menu li:eq(2)').hide();

//   document.addEventListener("DOMContentLoaded", function() {
//   var style = document.createElement("style");
//   style.textContent = "#MenuMobileListSection-menu > li:nth-child(3) { display: none; }";
//   document.head.appendChild(style);
// });
// }



  
// Littergenie nav link
  let littergenieLink = document.querySelector('[href*="littergenie.com"]');
      littergenieLink.setAttribute('target', '_blank');
      littergenieLink.setAttribute('rel', 'noopener');

  if(pageRegion === "CA" && pageLang === "en"){

    if(littergenieLink){
      littergenieLink.href = "https://www.littergenie.com/en-ca"; 
    }

  }

  if(pageRegion === "CA" && pageLang === "fr"){

    if(littergenieLink){
      littergenieLink.href = "https://www.littergenie.com/fr-ca"; 
      
    }
  }

  if(pageRegion === "DE"){

    if(littergenieLink){
      littergenieLink.href = "https://www.littergenie.com/de-de"; 
    }
  }

  if(pageRegion === "FR"){

    if(littergenieLink){
      littergenieLink.href = "https://www.littergenie.com/fr-fr"; 
    }
  }

      if(pageRegion === "GB"){

    if(littergenieLink){
      littergenieLink.href = "https://www.littergenie.com/en-uk"; 
    }
  }



  console.log("region " + pageRegion);


  document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector(".how-to-use-section-grid");

  if (!grid) return;

  const items = grid.querySelectorAll(".how-to-use-custom-item");
  const count = items.length;

  if (count === 3) {
    grid.classList.add("three-items");
  } else if (count === 4) {
    grid.classList.add("four-items");
  }
});





<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->